import React from 'react';
import { Navigate } from 'react-router-dom';
import { PagePathname } from './routes/paths';
import AgentEditPage from './pages/AgentEditPage/AgentEditPage';
import FinancePage from './pages/Finace/AllReceiptsPage';
import AllAgentsPage from './pages/AgentTable';
import AllInteressentenPage from './pages/Leads/LeadsTable';
import DashboardPage from './pages/DashboardPage';
import ReceiptPage from './pages/Finace/ReceiptEditPage';
import OptionsPage from './pages/Options/BookingAccount/OptionsPage';
import ServicesPage from './pages/Options/ServicesPage';
import RankPage from './pages/Options/RankPage/RankPage';
import LevelsPage from './pages/Options/LevelsPage/LevelsPage';
import UserPage from './pages/Options/UserPage/UserPage';
import BranchofficePage from './pages/Options/BrachofficePage/BranchofficePage';
import TaxPage from './pages/Options/TaxPage';
import CounrysPage from './pages/Options/CountrysPage/index';
import ContractTypsPage from './pages/Options/ContractTypsPage/ContractTypsPage';
import MontlyAccountingPage from './pages/Finace/MontlyAccountingPage/MountlyAccountingPage';
import AdminPage from './pages/Options/AdminPage/index';
import HandbuchPage from './features/options/pages/HandbuchPage';
import SystemProviderListPage from './pages/Options/SystemProviderPage/SystemProviderListPage';
import SystemProviderFormPage from './pages/Options/SystemProviderPage/SystemProviderFormPage';
import LetterTemplatesPage from './pages/Options/LetterTemplatesPage/LetterTemplatesPage';
import LetterTemplateFormPage from './pages/Options/LetterTemplatesPage/LetterTemplateFormPage';
import VertragsvorlagePage from './features/templates/contractEditor/pages/VertragsvorlagePage';
import VertragsentwurfPage from './features/contract-creation/pages/VertragsentwurfPage';
import VertragseditorProbePage from './features/templates/contractEditor/pages/VertragseditorProbePage';
import EinstellungenUebersichtPage from './pages/Options/EinstellungenUebersichtPage';
import Map from './pages/Map';
import ImportShopReceipts from './pages/Finace/ImportShopReceipts';
import InteressentPage from './pages/Leads/EditPage';
import ServicesReportPage from './pages/Reports/ServicesReportPage/index';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import McpAdminPage from './pages/Options/McpAdminPage';
import NutzungPage from './features/usage-tracking/pages/NutzungPage';

export { PagePathname };

export type Page = {
  title: string;
  path: string;
  render: JSX.Element;
  showInNavbar: boolean;
  superAdminOnly?: boolean;
};

const pages: Page[] = [
  {
    title: 'Dashboard',
    path: PagePathname.dashboard,
    render: <DashboardPage />,
    showInNavbar: true,
  },
  {
    title: 'Berater',
    path: PagePathname.alleBerater,
    render: <AllAgentsPage />,
    showInNavbar: true,
  },

  {
    title: 'Belege',
    path: PagePathname.alleBelege,
    render: <FinancePage />,
    showInNavbar: true,
  },
  {
    title: 'BasePath Buchhaltung',
    path: PagePathname.buchhaltung,
    render: <Navigate to={PagePathname.alleBelege} replace />,
    showInNavbar: true,
  },
  {
    title: 'Abschluss',
    path: PagePathname.abschluss,
    render: <MontlyAccountingPage />,
    showInNavbar: true,
  },
  {
    title: 'Buchungskonten',
    path: PagePathname.buchungskonten,
    render: <OptionsPage />,
    showInNavbar: true,
  },
  {
    title: 'Einstellungen',
    path: PagePathname.einstellung,
    render: <EinstellungenUebersichtPage />,
    showInNavbar: true,
  },
  {
    title: 'Ränge',
    path: PagePathname.ränge,
    render: <RankPage />,
    showInNavbar: true,
  },
  {
    title: 'Levels',
    path: PagePathname.levels,
    render: <LevelsPage />,
    showInNavbar: true,
  },
  {
    title: 'Benutzer',
    path: PagePathname.benutzer,
    render: <UserPage />,
    showInNavbar: true,
  },
  {
    title: 'Länder',
    path: PagePathname.länder,
    render: <CounrysPage />,
    showInNavbar: true,
  },

  {
    title: 'Vertragsarten',
    path: PagePathname.vertragsarten,
    render: <ContractTypsPage />,
    showInNavbar: true,
  },
  {
    title: 'Marken',
    path: PagePathname.marken,
    render: <BranchofficePage />,
    showInNavbar: true,
  },
  {
    title: 'Leistungen',
    path: PagePathname.leistungen,
    render: <ServicesPage />,
    showInNavbar: true,
  },
  {
    title: 'Leistungen Bericht',
    path: PagePathname.leistungReport,
    render: <ServicesReportPage />,
    showInNavbar: true,
  },
  {
    title: 'BasePath Berichte',
    path: PagePathname.berichte,
    render: <Navigate to={PagePathname.leistungReport} />,
    showInNavbar: true,
  },
  {
    title: 'Steuern',
    path: PagePathname.steuern,
    render: <TaxPage />,
    showInNavbar: true,
  },

  {
    title: 'Berater erstellen',
    path: PagePathname.beraterErstellen,
    render: <AgentEditPage />,
    showInNavbar: true,
  },
  {
    title: 'Berater bearbeiten',
    path: PagePathname.beraterBearbeiten,
    render: <AgentEditPage />,
    showInNavbar: true,
  },
  {
    title: 'Belege erstellen',
    path: PagePathname.belegeErstellen,
    render: <ReceiptPage />,
    showInNavbar: true,
  },
  {
    title: 'Belege',
    path: PagePathname.belege,
    render: <ReceiptPage />,
    showInNavbar: true,
  },
  {
    title: 'Systemdienstleister',
    path: PagePathname.systemdienstleister,
    render: <SystemProviderListPage />,
    showInNavbar: true,
  },
  {
    title: 'Systemdienstleister anlegen',
    path: PagePathname.systemdienstleisterNeu,
    render: <SystemProviderFormPage />,
    showInNavbar: true,
  },
  {
    title: 'Systemdienstleister bearbeiten',
    path: PagePathname.systemdienstleisterBearbeiten,
    render: <SystemProviderFormPage />,
    showInNavbar: true,
  },
  {
    title: 'Briefvorlagen',
    path: PagePathname.briefvorlagen,
    render: <LetterTemplatesPage />,
    showInNavbar: true,
  },
  {
    title: 'Briefvorlage erstellen',
    path: PagePathname.briefvorlagenNeu,
    render: <LetterTemplateFormPage />,
    showInNavbar: true,
  },
  {
    title: 'Briefvorlage bearbeiten',
    path: PagePathname.briefvorlagenBearbeiten,
    render: <LetterTemplateFormPage />,
    showInNavbar: true,
  },
  {
    title: 'Vertragsvorlage erstellen',
    path: PagePathname.vertragsvorlagenNeu,
    render: <VertragsvorlagePage />,
    showInNavbar: true,
    superAdminOnly: true,
  },
  {
    title: 'Vertragsvorlage bearbeiten',
    path: PagePathname.vertragsvorlagenBearbeiten,
    render: <VertragsvorlagePage />,
    showInNavbar: true,
    superAdminOnly: true,
  },
  {
    // RITA-1547: Entwurf „Vertrag erstellen“ beim Berater bearbeiten. Kein Navbar-Eintrag; erreichbar über
    // „Bearbeiten“/„Weiterbearbeiten“ im Bereich „Vertrag“. SUPERADMIN-only (Routes.tsx RequireSuperAdmin).
    // RITA-1552: Dieselbe Route mit `?vorgang=ruecksendung` ist „Rücksendung drucken – Bearbeiten“ (Skizze Rücklauf,
    // Bild E); den Titel der Seite setzt sie je Vorgang selbst.
    title: 'Vertrag erstellen – Bearbeiten',
    path: PagePathname.beraterVertragBearbeiten,
    render: <VertragsentwurfPage />,
    showInNavbar: false,
    superAdminOnly: true,
  },
  {
    // RITA-1525 (Epic RITA-901): Probeansicht des eigenen Vertragseditors (Seitenansicht, PDF-Probe).
    // Kein Navbar-Eintrag; SUPERADMIN-only wie die Vertragsvorlagen (Routes.tsx RequireSuperAdmin).
    title: 'Vertragseditor (Probe)',
    path: PagePathname.vertragseditorProbe,
    render: <VertragseditorProbePage />,
    showInNavbar: false,
    superAdminOnly: true,
  },
  {
    title: 'Admin panel',
    path: PagePathname.adminPanel,
    render: <AdminPage />,
    showInNavbar: true,
  },
  {
    title: 'Handbuch',
    path: PagePathname.handbuch,
    render: <HandbuchPage />,
    showInNavbar: true,
  },
  {
    // RITA-1505 (Nutzungserfassung Phase 2c): Auswertung der Nutzungsdaten.
    // Kein Navbar-Eintrag — der Zugang laeuft ueber die Kachel auf /einstellung.
    title: 'Nutzung',
    path: PagePathname.nutzung,
    render: <NutzungPage />,
    showInNavbar: false,
    // CONTRACT: SUPERADMIN-only — non-SUPERADMINs werden zu /404 umgeleitet (Routes.tsx RequireSuperAdmin)
    superAdminOnly: true,
  },
  {
    title: 'MCP Administration',
    path: PagePathname.mcpAdministration,
    render: <McpAdminPage />,
    showInNavbar: true,
    // CONTRACT: SUPERADMIN-only — non-SUPERADMINs werden zu /404 umgeleitet (Routes.tsx RequireSuperAdmin)
    superAdminOnly: true,
  },
  {
    title: 'Profil',
    path: PagePathname.profil,
    render: <ProfilePage />,
    showInNavbar: false,
  },
  {
    title: 'Karte',
    path: PagePathname.karte,
    render: <Map />,
    showInNavbar: true,
  },
  {
    title: 'Shopify Belege',
    path: PagePathname.shopifyBelege,
    render: <ImportShopReceipts />,
    showInNavbar: true,
  },
  ...(process.env.NODE_ENV === 'development'
    ? [
        {
          title: 'Interessenten',
          path: '/all-interessents',
          render: <AllInteressentenPage />,
          showInNavbar: false,
        },
        {
          title: 'Interessenten anlegen',
          path: '/create-interessent',
          render: <InteressentPage />,
          showInNavbar: false,
        },
        {
          title: 'Interessenten bearbeiten',
          path: '/interessent/:number',
          render: <InteressentPage />,
          showInNavbar: false,
        },
        {
          title: 'Interessenten anlegen',
          path: '/create-interessent',
          render: <InteressentPage />,
          showInNavbar: true,
        },
        {
          title: 'Interessenten bearbeiten',
          path: '/interessent/:number',
          render: <InteressentPage />,
          showInNavbar: true,
        },
      ]
    : []),
];

export default pages;
